import React from 'react'
import SearchBar from './subcomponent/searchbar';
import ReactDOM from 'react-dom';
import { useSearchStore } from '../stores/search.store';
import axios from 'axios';
import CourseCard from './subcomponent/CourseCard';

export default function SearchCourses({content, layout}) {

  const title = useSearchStore(state => state.title);
  const type = useSearchStore(state => state.type);
  const date = useSearchStore(state => state.date);

  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [isAllCourses, setIsAllCourses] = React.useState(false);
  const perPage = 9;
  

  const [results, setResults] = React.useState([]);

  const searchCourses = async (title, type, date) => {
    let formattedDate = '';
    // is date a string?

    if(date && typeof date !== 'string') {
      formattedDate = date.toISOString().split('T')[0];
    }
    const searchUrl = `/wp-json/newtyne/v2/courses?title=${title}&course_category=${type}&date=${formattedDate}`
    const { data } = await axios.get(searchUrl);

    setPage(1);
    setTotalPages(Math.ceil(data.length / perPage));

    setResults(data.courses);
    setIsAllCourses(data.all_courses);
  }

  React.useEffect(() => {
    searchCourses(title, type, date);
  }, []);

  const paginatedResults = results?.slice((page - 1) * perPage, page * perPage) || [];

  return (
    <div className="container mx-auto p-4">
      <SearchBar onSearch={searchCourses} />
      
      {
        isAllCourses &&
        <h3 className='mt-8'>
          Showing all courses
        </h3>
      }
      {
        !isAllCourses && results.length === 0 &&
        <h3 className='mt-8'>
          No results found
        </h3>
      }
      {
        !isAllCourses && results.length > 0 &&
        <h3 className='mt-8'>
          Showing {paginatedResults.length} result<span>{paginatedResults.length > 1 ? 's' : ''}</span>
        </h3>
      }
      {/* {
        results.length > 0 &&
        <div className="ml-4 text-sm mt-4 text-gray-500">
          Showing {perPage * (page - 1) + 1} to {perPage * page > results.length ? results.length : perPage * page} of {results.length} result{results.length > 1 ? 's' : ''}
        </div>
      } */}
      <div className="cardlist__cardcontainer cardlist__cardcontainer--break mt-12">
        {paginatedResults.map((result, index) => {
          let firstDate = "TBC";
          let firstToDate = null;
          let subdate = '';

          if(result.fields.dates) {
            firstDate = result.fields.dates[0].date_from;
            firstToDate = result.fields.dates[0].date_to;
            if (firstToDate !== null) {
              firstDate = `${firstDate} - ${firstToDate}`;
            }
            if (firstDate === null) {
              firstDate = "TBC";
            }
            if (result.fields.dates?.length > 1) {
              const maxCourses = result.fields.dates?.length;
              subdate = `+ ${maxCourses - 1} more dates`;
            }

            let allDatesString = "";
            result.fields.dates.forEach((date, index) => {
              let dateFrom = date.date_from;
              let dateTo = date.date_to;
              if (dateTo !== null) {
                dateFrom = `${dateFrom} - ${dateTo}`;
              }
              if (dateFrom === null) {
                dateFrom = "TBC";
              }
              allDatesString = `${allDatesString}<br />${dateFrom}`;
            });
          }
          

          return ( 
            <>
              <CourseCard 
                title={result.post_title}
                date={firstDate}
                subdate={subdate}
                category={result.fields.course_categories[0].name}
                text={result.fields.course_excerpt}
                link={result.fields.url}
                image={result.fields.image}
                key={`cardresult-${index}`} 
                price={result.fields.price}
                icon={result.fields.course_categories[0].icon} 
                iconBackgroundColour={result.fields.course_categories[0].icon_background_colour}
                
                />
            </>            
          )
        } )}
      </div>
      {
        totalPages > 1 &&
        <div className="flex justify-center mt-12 p-4 px-12 rounded-full shadow-lg w-fit mx-auto">
          <button className="" onClick={() => setPage(page - 1)} disabled={page === 1}>
            <i className="fas fa-chevron-left mr-2"></i>
            Previous
          </button>
          <div className="ml-4 text-gray-500">Page {page} of {totalPages}</div>
          <button className=" ml-4 hover:text-gray-500"onClick={() => setPage(page + 1)} disabled={page === totalPages}>
            Next
            <i className="fas fa-chevron-right ml-2"></i>
          </button>
        </div>
      }
    </div>
  ); 
  
}

